import { Observable } from 'rxjs';

export default function makeShortCutKeyObservable(matchesShortCutKey) {
    var ignoreTags = ['INPUT', 'SELECT', 'TEXTAREA'];

    var shortcut$ = Observable.fromEvent(document, 'keydown')
        .filter(e => ! e.target.isContentEditable)
        .filter(e => ! ignoreTags.includes(e.target.tagName))
        .filter(e => {
            var keyPressed = String.fromCharCode(e.keyCode).toLowerCase();
            return matchesShortCutKey({
                keyPressed,
                altKey: e.altKey,
                keyCode: e.keyCode
            });
        });  

    return shortcut$;
}

// Example of matchesShortCutKey
// var matchesShortCutKey = ({keyPressed, altKey}) => altKey && keyPressed == 'e';



// WEBPACK FOOTER //
// ./app/utils/makeShortCutKeyObservable.js